import { RIDE_STATUSES, TERM_REASONS, resolveDisplayTermReason } from "score-common";

// #2799. The three outcomes the Set Outcome modal can stamp and clear
// (scratch is FVD-owned and has its own control; elimination is a sheet-level
// act). Each one is its own score-api mechanism, and each mechanism clears
// ride.terminationReason ONLY when the stamp's `source` is its own
// (score-api handlers/ride.js undoRideNoShow / undoRideExcused /
// undoRideWithdrawn), so "Normal" has to call the DELETE belonging to the
// outcome that is actually set. Calling a different one 409s and leaves the
// stamp behind.
export const OUTCOME_KEYS = {
  NO_SHOW: "noShow",
  WITHDRAWN: "withdrawn",
  EXCUSED: "excused",
};

// terminationReason.source -> outcome key
const SOURCE_TO_KEY = {
  "no-show": OUTCOME_KEYS.NO_SHOW,
  withdrawn: OUTCOME_KEYS.WITHDRAWN,
  excused: OUTCOME_KEYS.EXCUSED,
};

// Which of the three outcomes is currently set on this ride by one of THIS
// modal's mechanisms, or null (no outcome, or one set elsewhere such as a
// sheet elimination or a scratch). The stamp's own `source` is authoritative;
// the ride-level active flag covers a pre-stamp row.
export function activeOutcomeKey(ride) {
  const fromSource = SOURCE_TO_KEY[ride?.terminationReason?.source];
  if (fromSource) return fromSource;
  if (ride?.noShow?.active === true) return OUTCOME_KEYS.NO_SHOW;
  if (ride?.excused?.active === true) return OUTCOME_KEYS.EXCUSED;
  if (ride?.withdrawn?.active === true) return OUTCOME_KEYS.WITHDRAWN;
  return null;
}

// The ride's outcome word for the badge, read through score-common's
// deriveRideTermReason (via resolveDisplayTermReason, which only adds the
// bare-SCRATCHED-with-no-reason case on top of it). Null means no badge.
export function rideOutcomeBadgeReason(ride, sheets) {
  return resolveDisplayTermReason(ride, sheets);
}

// A scratched ride's outcome is administrative and FVD-owned (USEF DR126.3.3),
// and un-scratching is the existing separate control, so Set Outcome is off.
export function isSetOutcomeDisabled(ride) {
  return ride?.status === RIDE_STATUSES.SCRATCHED;
}

// Static i18n key per TERM_REASONS value (no dynamic key construction).
export const OUTCOME_BADGE_KEYS = {
  [TERM_REASONS.NO_SHOW]: "rideEditor.outcomeBadge.noShow",
  [TERM_REASONS.WITHDRAWN]: "rideEditor.outcomeBadge.withdrawn",
  [TERM_REASONS.EXCUSED]: "rideEditor.outcomeBadge.excused",
  [TERM_REASONS.ELIMINATED]: "rideEditor.outcomeBadge.eliminated",
  [TERM_REASONS.SCRATCHED]: "rideEditor.outcomeBadge.scratched",
};
